import { CATALYST_COLORS_WITH_HEXCODES } from "@certa/catalyst/constants/styles";
import type { BoxProps, TextProps } from "../engines/coreComponents/types";
import { Align, FlexDirection } from "../engines/layoutEngine/yoga.types";
import { BoxNode, TextNode } from "../engines/renderingEngine/primitiveNodes";
import type { FSC } from "../engines/renderingEngine/fsc.types";

type NoChildrenProps = {
  key: string;
  title: string;
};

export const NoChildren: FSC<NoChildrenProps> = ({ key, title }) => {
  const noChildrenContainer = BoxNode({
    key: `${key}`,
    style: NoChildrenContainerStyle,
    children: [
      TextNode({
        key: `${key}-Text`,
        text: title || " Empty ",
        textStyle: NoChildrenTextStyle,
        style: {},
        children: []
      })
    ]
  });

  return noChildrenContainer;
};

const NoChildrenContainerStyle: BoxProps["style"] = {
  alignItems: Align.Center,
  //   justifyContent: Justify.Center,
  paddingTop: 4,
  paddingBottom: 4,
  marginLeft: 28,
  flexDirection: FlexDirection.Row,
  width: "100%"
};

const NoChildrenTextStyle: TextProps["textStyle"] = {
  fontSize: 12,
  italic: true,
  color: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_700
};
